module.exports = __webpack_public_path__ + "static/media/irochima.d03af7b9.jpg";